import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories, comics, testimonials } from '@/mocks/comics';

function HeroSection() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative w-full h-screen min-h-[700px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Dreamy%20soft%20atmospheric%20reading%20scene%20with%20warm%20golden%20ambient%20light%2C%20floating%20cherry%20blossom%20petals%2C%20soft%20teal%20and%20warm%20peach%20gradient%20background%2C%20cozy%20reading%20nook%20with%20plush%20pillows%2C%20Korean%20webtoon%20aesthetic%2C%20dreamy%20bokeh%20effect%2C%20magical%20atmosphere%2C%20soft%20focus%20style&width=1920&height=1080&seq=hero-bg-main&orientation=landscape)`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50" />

      <div className="relative z-10 h-full w-full flex flex-col justify-center px-6 md:px-16 lg:px-24">
        <div className="max-w-3xl">
          <p className="text-accent-300 text-sm md:text-base font-medium tracking-widest mb-4 opacity-0 animate-[fadeInUp_0.8s_ease-out_0.2s_forwards]">
            免费韩国漫画阅读平台
          </p>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6 opacity-0 animate-[fadeInUp_0.8s_ease-out_0.4s_forwards]">
            蜜桃少年
            <br />
            等热门韩漫
            <br />
            免费畅读
          </h1>
          <p className="text-white/70 text-base md:text-lg max-w-xl leading-relaxed mb-8 opacity-0 animate-[fadeInUp_0.8s_ease-out_0.6s_forwards]">
            073漫画网 — 汇聚海量韩国漫画资源，画质高清、更新迅速、完全免费。随时随地，畅享漫画世界的精彩。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 opacity-0 animate-[fadeInUp_0.8s_ease-out_0.8s_forwards]">
            <Link
              to="/category/rexue"
              className="px-8 py-3.5 bg-primary-500 text-white rounded-full text-sm font-semibold text-center whitespace-nowrap hover:bg-primary-600 transition-all duration-300"
            >
              开始阅读 <i className="ri-arrow-right-line ml-1"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-full text-sm font-semibold text-center whitespace-nowrap hover:bg-white/25 transition-all duration-300"
            >
              了解更多
            </Link>
          </div>
        </div>

        <div className="absolute bottom-8 md:bottom-12 right-6 md:right-16 flex flex-col gap-2">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl px-5 py-4 border border-white/20">
            <p className="text-white/60 text-xs mb-1">今日更新</p>
            <p className="text-white text-2xl font-bold">12</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl px-5 py-4 border border-white/20">
            <p className="text-white/60 text-xs mb-1">已收录漫画</p>
            <p className="text-white text-2xl font-bold">3,800+</p>
          </div>
        </div>

        <div className="absolute bottom-10 left-1/2 -translate-x-1/2">
          <div className="w-6 h-10 border-2 border-white/40 rounded-full flex items-start justify-center pt-2">
            <div className="w-1 h-2 bg-white/60 rounded-full animate-bounce" />
          </div>
        </div>
      </div>
    </section>
  );
}

function CategoryNav() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-center mb-4 leading-tight">
          探索你的
          <span className="text-accent-500">漫画世界</span>
          <br />
          <span className="text-primary-500">发现心头所爱</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 mt-10">
          <Link
            to="/category/lianai"
            className="md:row-span-2 relative group rounded-2xl overflow-hidden h-64 md:h-auto"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%20of%20a%20couple%20in%20cherry%20blossom%20garden%2C%20soft%20pink%20and%20peach%20tones%2C%20dreamy%20romantic%20atmosphere%2C%20Korean%20webtoon%20art%20style%2C%20clean%20composition&width=800&height=1000&seq=cat-card-01&orientation=portrait"
              alt="恋爱漫画"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <span className="inline-block px-3 py-1 bg-primary-500/90 text-white text-xs rounded-full mb-2 whitespace-nowrap">热门分类</span>
              <h3 className="text-white text-xl md:text-2xl font-heading font-bold">恋爱漫画</h3>
              <p className="text-white/70 text-sm mt-1">甜蜜浪漫的恋爱故事</p>
            </div>
          </Link>

          <Link
            to="/category/rexue"
            className="relative group rounded-2xl overflow-hidden h-48 md:h-auto"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20fantasy%20illustration%20with%20epic%20battle%20scene%2C%20dynamic%20composition%2C%20warm%20orange%20and%20teal%20tones%2C%20Korean%20webtoon%20style%2C%20clean%20background&width=800&height=500&seq=cat-card-02&orientation=landscape"
              alt="热血漫画"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <h3 className="text-white text-lg font-heading font-bold">热血漫画</h3>
              <p className="text-white/70 text-xs mt-1">激情澎湃的战斗冒险</p>
            </div>
          </Link>

          <Link
            to="/category/qihuan"
            className="relative group rounded-2xl overflow-hidden h-48 md:h-auto"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20illustration%20with%20magical%20world%2C%20floating%20islands%2C%20pastel%20color%20palette%2C%20whimsical%20atmosphere%2C%20Korean%20webtoon%20style%2C%20clean%20composition&width=800&height=500&seq=cat-card-03&orientation=landscape"
              alt="奇幻漫画"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <h3 className="text-white text-lg font-heading font-bold">奇幻漫画</h3>
              <p className="text-white/70 text-xs mt-1">天马行空的奇异世界</p>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}

function HotRecommendations() {
  const featured = comics.filter((c) => c.featured).slice(0, 3);

  return (
    <section className="py-16 md:py-24 px-4 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="text-xs font-medium text-secondary-600 uppercase tracking-wider">Editor's Pick</span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mt-2 leading-tight">
              热门推荐
            </h2>
          </div>
          <Link
            to="/category/rexue"
            className="hidden md:flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {featured.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className="group"
              data-product-shop
            >
              <div className="bg-background-50 rounded-2xl border border-background-200 overflow-hidden hover:border-accent-300 transition-all duration-300">
                <div className="aspect-[3/4] relative overflow-hidden">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3 flex gap-2">
                    <span className="px-2.5 py-1 bg-primary-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
                      {comic.rating} 分
                    </span>
                    {comic.status === '连载中' && (
                      <span className="px-2.5 py-1 bg-secondary-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
                        {comic.status}
                      </span>
                    )}
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-500 transition-colors">
                    {comic.title}
                  </h3>
                  <p className="text-foreground-500 text-xs mt-1">{comic.author}</p>
                  <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200">
                    <span className="text-foreground-400 text-xs">
                      <i className="ri-eye-line mr-1"></i>
                      {(comic.views / 10000).toFixed(0)}万阅读
                    </span>
                    <span className="text-foreground-400 text-xs">
                      <i className="ri-file-list-2-line mr-1"></i>
                      {comic.chapters}话
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function RankingsTestimonials() {
  const topComics = [...comics].sort((a, b) => b.rating - a.rating).slice(0, 5);

  return (
    <section className="py-16 md:py-24 px-4 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          <div className="lg:w-3/5">
            <div className="flex items-center gap-2 mb-8">
              <span className="w-2 h-2 rounded-full bg-accent-500"></span>
              <span className="text-xs font-medium text-foreground-600 uppercase tracking-wider">本周口碑榜</span>
            </div>
            <div className="relative">
              <span className="absolute -top-6 -left-2 text-7xl md:text-8xl font-heading font-bold text-accent-200 select-none leading-none">
                &ldquo;
              </span>
              <p className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 leading-relaxed relative z-10">
                好漫画不需要
                <br />
                华丽的辞藻来形容
                <br />
                翻开它你就懂了
              </p>
            </div>
            <div className="mt-6 flex items-center gap-3">
              <span className="font-heading text-lg font-bold text-foreground-950">TOP读者精选</span>
              <span className="flex items-center gap-1 text-accent-500">
                <i className="ri-verified-badge-fill"></i>
                <span className="text-xs text-foreground-500">真实评分</span>
              </span>
            </div>

            <div className="mt-8 space-y-3">
              {topComics.map((comic, index) => (
                <Link
                  key={comic.id}
                  to={`/comic/${comic.slug}`}
                  className="flex items-center gap-4 p-3 rounded-xl hover:bg-background-100 transition-colors group"
                >
                  <span className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${
                    index === 0 ? 'bg-primary-500 text-white' :
                    index === 1 ? 'bg-accent-500 text-white' :
                    index === 2 ? 'bg-secondary-500 text-white' :
                    'bg-background-200 text-foreground-500'
                  }`}>
                    {index + 1}
                  </span>
                  <div className="flex-1 min-w-0">
                    <h4 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                      {comic.title}
                    </h4>
                    <p className="text-xs text-foreground-500">{comic.author}</p>
                  </div>
                  <div className="flex items-center gap-1 text-primary-500">
                    <i className="ri-star-fill text-sm"></i>
                    <span className="text-sm font-semibold">{comic.rating}</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:w-2/5">
            <div className="relative h-full min-h-[400px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20black%20and%20white%20portrait%20of%20a%20young%20Asian%20person%20reading%20a%20book%2C%20side%20profile%2C%20soft%20dramatic%20lighting%2C%20artistic%20photography%2C%20contemplative%20mood%2C%20clean%20white%20background%2C%20high%20contrast%20monochrome&width=600&height=800&seq=testimonial-portrait&orientation=portrait"
                alt="读者口碑"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="bg-white/90 backdrop-blur-sm rounded-xl p-5">
                  <div className="flex items-center gap-1 mb-2">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-primary-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-foreground-800 text-sm leading-relaxed">
                    {testimonials[0].quote}
                  </p>
                  <div className="flex items-center gap-2 mt-3">
                    <div className="w-8 h-8 rounded-full overflow-hidden">
                      <img src={testimonials[0].avatar} alt={testimonials[0].name} className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{testimonials[0].name}</p>
                      <div className="flex items-center gap-1">
                        <i className="ri-verified-badge-fill text-secondary-500 text-xs"></i>
                        <span className="text-xs text-foreground-500">已验证读者</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function LatestUpdates() {
  const latest = [...comics].sort(() => Math.random() - 0.5).slice(0, 6);

  return (
    <section className="py-16 md:py-24 px-4 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
          <div className="lg:max-w-2xl">
            <span className="text-xs font-medium text-secondary-600 uppercase tracking-wider">Latest Updates</span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-secondary-600 mt-2 leading-tight">
              最新章节
              <br />
              不容
              <span className="inline-block align-middle mx-2 w-12 h-12 md:w-16 md:h-16 rounded-full overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20chibi%20cute%20character%20with%20surprised%20expression%2C%20warm%20peach%20color%20scheme%2C%20simple%20clean%20style&width=120&height=120&seq=inline-img-01&orientation=portrait"
                  alt=""
                  className="w-full h-full object-cover"
                />
              </span>
              错过
            </h2>
          </div>
          <div className="flex gap-3">
            <Link
              to="/category/rexue"
              className="px-6 py-3 bg-secondary-500 text-white rounded-full text-sm font-semibold whitespace-nowrap hover:bg-secondary-600 transition-colors"
            >
              全部更新 <i className="ri-arrow-right-line ml-1"></i>
            </Link>
            <Link
              to="/category/rexue"
              className="px-6 py-3 border-2 border-secondary-300 text-secondary-600 rounded-full text-sm font-semibold whitespace-nowrap hover:bg-secondary-50 transition-colors"
            >
              热门排行
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latest.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className="flex gap-4 p-4 bg-background-50 rounded-xl border border-background-200 hover:border-accent-300 transition-all duration-300 group"
              data-product-shop
            >
              <div className="w-20 h-28 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <h4 className="font-heading text-sm font-bold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
                    {comic.title}
                  </h4>
                  <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
                </div>
                <div>
                  <div className="flex flex-wrap gap-1.5 mt-2">
                    {comic.tags.slice(0, 2).map((tag) => (
                      <span key={tag} className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs rounded-full whitespace-nowrap">
                        {tag}
                      </span>
                    ))}
                  </div>
                  <p className="text-xs text-foreground-400 mt-2">
                    更新至第{comic.chapters}话 · {comic.updateDate}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-36 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Warm%20cozy%20reading%20corner%20with%20afternoon%20sunlight%2C%20wooden%20desk%20with%20tablet%20displaying%20webtoon%2C%20soft%20ambient%20lighting%2C%20warm%20golden%20hour%20tones%2C%20comfortable%20home%20setting%2C%20Korean%20aesthetic%20interior%2C%20peaceful%20atmosphere&width=1920&height=800&seq=cta-bg&orientation=landscape)`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />

      <div className="relative z-10 max-w-3xl mx-auto text-center px-4">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-white tracking-wide leading-tight">
          现在就开始
          <br />
          你的漫画之旅
        </h2>
        <p className="text-white/70 text-base md:text-lg mt-4 md:mt-6 leading-relaxed max-w-xl mx-auto">
          数千部韩国漫画等你来探索，完全免费，无需付费
        </p>
        <Link
          to="/category/rexue"
          className="inline-flex items-center gap-3 mt-8 md:mt-10 px-8 py-4 bg-foreground-950 text-white rounded-full text-sm font-semibold whitespace-nowrap hover:bg-foreground-800 transition-all duration-300 group"
        >
          <span className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
            <i className="ri-play-fill text-white text-sm"></i>
          </span>
          <span>立即免费阅读</span>
          <i className="ri-arrow-right-up-line text-lg group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
        </Link>
      </div>
    </section>
  );
}

function FAQSection() {
  const faqs = [
    {
      q: '073漫画网上的漫画真的完全免费吗？',
      a: '是的！073漫画网上的所有漫画作品完全免费阅读，无需付费，无需订阅。我们致力于为广大漫画爱好者提供无障碍的阅读体验。',
    },
    {
      q: '支持在手机上阅读吗？',
      a: '当然支持！073漫画网采用响应式设计，完美适配手机、平板和电脑等多种设备，让你随时随地畅享漫画阅读的乐趣。',
    },
    {
      q: '漫画更新频率如何？',
      a: '我们与多家韩国漫画工作室保持紧密合作，热门作品通常每周更新1-2次，确保读者能第一时间看到最新章节。',
    },
    {
      q: '如何找到我想看的漫画？',
      a: '你可以通过首页的分类导航浏览不同类型的漫画，也可以使用搜索功能（即将上线）直接查找你喜欢的作品。',
    },
  ];

  return (
    <section className="py-16 md:py-24 px-4 md:px-10 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 text-center mb-12">
          常见问题
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <details key={index} className="group bg-background-100 rounded-xl border border-background-200">
              <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">{faq.q}</h3>
                <span className="flex-shrink-0 w-8 h-8 rounded-full bg-background-200 flex items-center justify-center group-open:rotate-45 transition-transform duration-300">
                  <i className="ri-add-line text-foreground-600"></i>
                </span>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function HomePage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '073漫画网 - 免费韩国漫画阅读平台',
            description: '073漫画网是免费看韩国漫画的便捷平台，蜜桃少年等热门韩国漫画作品已为您精心准备。',
            url: 'https://073manhua.com',
            isPartOf: {
              '@type': 'WebSite',
              name: '073漫画网',
              url: 'https://073manhua.com',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                { '@type': 'ListItem', position: 1, name: '首页', item: 'https://073manhua.com' },
              ],
            },
          }),
        }}
      />
      <HeroSection />
      <CategoryNav />
      <HotRecommendations />
      <RankingsTestimonials />
      <LatestUpdates />
      <CTASection />
      <FAQSection />
    </>
  );
}